export function numberFormat(number, decimals = 2, simbol = "$") {
    return `${simbol} ${(number).toFixed(decimals).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
}


// WEBPACK FOOTER //
// ./src/utils/numberFormat.js